<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    size: {
        type: String,
        default: '1', // 1 - 5
    }
});

const labelClasses = computed((): string => {
    let classes = 'form-label text-subtitle-1 ';
    classes += 'form-label-size-'+props.size;

    return classes
});



</script>

<template>
    <div :class="labelClasses">
        <template v-if="$slots.title">
            <slot name="title"></slot>
        </template>
        <template v-else>
            {{ $props.title }}
        </template>
    </div>
</template>